import Title from "antd/es/typography/Title"
import { BsAsterisk } from 'react-icons/bs'

const CamposObligatoriosLeyenda = () => {
    return <Title className="mt-0 mb-3" style={{ fontSize: 15 }}>Los campos marcados con <BsAsterisk style={{ color: "red" }} /> son obligatorios</Title>
}

export default CamposObligatoriosLeyenda